export default "__VITE_ASSET__CeDxMEOK__"